import React, { useState } from "react";
import { Award, Heart, Play, ShieldCheck } from "lucide-react";
import { IMG, VIDEOS } from "../../mock";
import { Reveal, PrimaryButton, Eyebrow } from "../common";
import VideoModal from "../VideoModal";

export default function Impact() {
  const [video, setVideo] = useState(false);

  return (
    <>
      {/* Story / non profit */}
      <section id="story" className="bg-white pb-24 pt-28 lg:pb-32 lg:pt-36">
        <div className="mx-auto grid max-w-[1400px] items-center gap-16 px-5 lg:grid-cols-2 lg:px-8">
          <Reveal>
            <div className="relative">
              <div className="absolute -left-6 -top-6 hidden h-32 w-32 rounded-3xl bg-ivi-mint lg:block" />
              <div className="relative overflow-hidden rounded-[28px] shadow-[0_30px_70px_-32px_rgba(24,40,32,0.45)]">
                <img
                  src={IMG.fijiNutrition}
                  alt="Public health and nutrition volunteer in Fiji"
                  className="aspect-[4/3] w-full object-cover"
                />
              </div>
              <div className="absolute -bottom-8 -right-4 w-64 rounded-3xl bg-ivi-slate p-6 text-white shadow-[0_24px_50px_-20px_rgba(24,40,32,0.6)] lg:-right-8">
                <p className="font-heading text-[13px] font-bold uppercase tracking-[0.16em] text-ivi-lime">
                  Live program
                </p>
                <p className="mt-2 font-heading text-[17px] font-bold leading-snug">
                  Public Health &amp; Nutrition in Fiji
                </p>
                <p className="mt-2 text-[13px] leading-relaxed text-white/70">
                  Run by a qualified health professional with local communities.
                </p>
              </div>
            </div>
          </Reveal>

          <div>
            <Eyebrow>Proud charity &amp; non profit org</Eyebrow>
            <h2 className="mt-5 font-heading text-[34px] font-extrabold leading-[1.12] tracking-[-0.02em] text-ivi-slate sm:text-[44px]">
              We&apos;re not motivated by profit.
              <span className="block text-ivi-greenDark">We&apos;re focused on people.</span>
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-ivi-slateSoft">
              <strong className="font-semibold text-ivi-slate">Established in 1989</strong>,
              Involvement Volunteers International are pioneers of volunteering overseas. Together
              with our partners worldwide, our mission is to educate, fight poverty, improve health
              and empower change through sustainable volunteer work in developing communities.
            </p>
            <p className="mt-4 text-[17px] leading-relaxed text-ivi-slateSoft">
              We fundraise for materials so that our impact is significant and lasting in the
              communities we work with not just for the weeks you&apos;re there.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {[
                { icon: Award, label: "Top Org 2019 · APAC Insider" },
                { icon: ShieldCheck, label: "CPD Certified Provider" },
                { icon: Heart, label: "Registered Charity" },
              ].map(({ icon: I, label }) => (
                <span
                  key={label}
                  className="inline-flex items-center gap-2 rounded-full border border-ivi-mintDeep bg-ivi-sand px-4 py-2.5 text-[13px] font-semibold text-ivi-slate"
                >
                  <I className="h-4 w-4 text-ivi-green" />
                  {label}
                </span>
              ))}
            </div>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <PrimaryButton as="a" href="#projects">
                See how it works
              </PrimaryButton>
              <button
                type="button"
                onClick={() => setVideo(true)}
                className="group inline-flex items-center gap-3 font-heading text-[15px] font-bold text-ivi-slate"
              >
                <span className="grid h-11 w-11 place-items-center rounded-full bg-ivi-mint text-ivi-greenDark transition-transform duration-200 group-hover:scale-110">
                  <Play className="ml-0.5 h-4 w-4 fill-current" />
                </span>
                Meet the people of Bali
              </button>
            </div>
          </div>
        </div>
      </section>

      <VideoModal open={video} onOpenChange={setVideo} videoId={VIDEOS.bali.id} title={VIDEOS.bali.title} />
    </>
  );
}
